const principles = [
  { icon: "ri-search-line", title: "多维核实", desc: "综合官方声明与多源公开报道交叉比对，标注事实与猜测。" },
  { icon: "ri-time-line", title: "完整脉络", desc: "保留爆发、发酵、高潮、反转全阶段，不做结果式的断章取义。" },
  { icon: "ri-refresh-line", title: "持续跟进", desc: "发酵中的事件随新进展即时更新，直到尘埃落定。" },
  { icon: "ri-eye-off-line", title: "审慎客观", desc: "对未经证实的网传内容明确标注，避免以讹传讹。" },
];

const testimonials = [
  { name: "加班族小林", role: "互联网从业者", text: "午休十分钟刷完整个瓜的时间线，终于不用在群里看别人聊得飞起自己一脸懵了。" },
  { name: "追剧党阿May", role: "娱乐内容爱好者", text: "把反转都留下来了这点我很喜欢，能看清一件事到底是怎么一步步演变的。" },
  { name: "球迷老周", role: "体育迷", text: "转会、换帅这种扑朔迷离的事，时间线一列出来就清楚多了，条理非常清晰。" },
];

export default function About() {
  return (
    <section id="about" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="grid gap-10 lg:grid-cols-2 lg:items-start">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-team-line text-sm"></i>
            关于吃瓜时间线
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
            不只是吃瓜，更是把每一场热闹看明白
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            吃瓜时间线诞生于一个朴素的想法：面对每天刷屏的热点，我们总在"看个热闹"和"看个明白"之间摇摆。
            太多人只看到热搜标题，却搞不清事件到底是怎么一步步走到今天的。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            所以我们专注于一件事——把每起热点事件的完整脉络按时间顺序整理成清晰的时间线。
            从最初的爆发，到逐渐发酵，再到可能出现的反转与进展，全程记录，不遗漏关键节点。
            我们想让你补课补得轻松，讨论讨论得明白。
          </p>
          <a
            href="#subscribe"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            和更多瓜友一起 <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {principles.map((p) => (
            <div key={p.title} className="rounded-2xl border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-extrabold text-foreground-950">{p.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-12 grid gap-4 md:grid-cols-3">
        {testimonials.map((t) => (
          <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-50 p-6">
            <div className="flex gap-1 text-secondary-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-base"></i>
              ))}
            </div>
            <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
              「{t.text}」
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-bold text-primary-700">
                {t.name.slice(0, 1)}
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-900">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}